import { inMarketTheme2 } from '@inmarket/inmarkit';

const oneDspTheme = inMarketTheme2;

export default oneDspTheme;
